module.exports = __webpack_public_path__ + "src/img/y_banana.png?faf24ab65e1566652bff8adeaf421f4e";


//////////////////
// WEBPACK FOOTER
// ./src/img/y_banana.png
// module id = 216
// module chunks = 0